import React, { useEffect, useState } from 'react'
import { func } from 'prop-types'
import cn from 'classnames'
import style from './TicketPending.module.scss'
import { UIIcon } from 'bora-material-ui'
import { reservationStatus } from '../../../../services/reservation/api'
import { allowedStatuses } from './PaymentResults'
import { translate } from '../../../Common/Translator'
import messages from '../../../../consts/messages'

const { ticketPendingRetries = 10 } = window.brandProps

const INTERVAL = 5000
const RETRY_LIMIT = ticketPendingRetries

// eslint-disable-next-line no-self-assign
const reloadPage = () => window.location.reload()

const TicketPending = ({ reservationToken }) => {
  const [pending, setPending] = useState(true)
  useEffect(() => {
    let retry = 0

    const interval = setInterval(async () => {
      retry += 1
      const status = await reservationStatus(reservationToken)

      if (allowedStatuses.includes(status)) {
        clearInterval(interval)
        reloadPage()
      }

      if (retry >= RETRY_LIMIT) {
        clearInterval(interval)
        setPending(false)
      }
    }, INTERVAL)

    return () => {
      clearInterval(interval)
    }
  }, [reservationToken, setPending])

  return (
    <section className={style.wrapper}>
      <div className={style.heading}>{translate(messages.paymentPendingHeading)}</div>
      <div className={cn(style.text, { [style.error]: !pending })}>
        {pending ? translate(messages.paymentPendingText) : translate(messages.paymentPendingErrorText)}
      </div>
      <UIIcon
        className={style.icon}
        height="100px"
        width="100px"
        display-if={!pending}
        type="sadFace"
        fill="cornflowerblue"
      />
      <div className={cn(style.spinner, { [style.hide]: !pending })}>
        <div className={style.ldsRipple}>
          <div></div>
          <div></div>
        </div>
      </div>
      <div className={style.actions}>
        <button className={style.reloadButton} onClick={reloadPage}>
          {translate(messages.paymentPendingButtonReload)}
        </button>
      </div>
    </section>
  )
}

TicketPending.propTypes = {
  reservationToken: func.string,
}

export { TicketPending }
